<template>
  <div class="about">
    <h1>This is an about page</h1>
    <a-button @click="getUserinfo">获取用户信息</a-button>
    
    <!-- 消息组件测试区域 -->
    <div class="message-test-section">
      <h2>全局消息组件测试</h2>
      <div class="button-group">
        <a-button type="primary" @click="showSuccessMessage">成功消息</a-button>
        <a-button status="danger" @click="showErrorMessage">错误消息</a-button>
        <a-button status="warning" @click="showWarningMessage">警告消息</a-button>
        <a-button @click="showInfoMessage">信息消息</a-button>
        <a-button @click="showCustomMessage">自定义消息</a-button>
        <a-button @click="clearAllMessages">清空所有消息</a-button>
      </div>
    </div>

    <!-- 模态框组件测试区域 -->
    <div class="modal-test-section">
      <h2>全局模态框组件测试</h2>
      <div class="button-group">
        <a-button type="primary" @click="showConfirmModal">确认对话框</a-button>
        <a-button @click="showInfoModal">信息对话框</a-button>
        <a-button status="warning" @click="showWarningModal">警告对话框</a-button>
        <a-button status="danger" @click="showErrorModal">错误对话框</a-button>
        <a-button @click="showCustomModal">自定义模态框</a-button>
        <a-button @click="showFormModal">表单模态框</a-button>
      </div>
    </div>

    <!-- 抽屉测试区域 -->
    <div class="drawer-test-section">
      <h2>抽屉组件测试</h2>
      <div class="button-group">
        <a-button type="primary" @click="showRightDrawer">右侧抽屉</a-button>
        <a-button @click="showLeftDrawer">左侧抽屉</a-button>
        <a-button @click="showTopDrawer">顶部抽屉</a-button>
        <a-button @click="showBottomDrawer">底部抽屉</a-button>
        <a-button @click="showCustomDrawer">自定义抽屉</a-button>
        <a-button @click="showFormDrawer">表单抽屉</a-button>
      </div>
    </div>

    <!-- 自定义模态框示例 -->
    <ZlModal
      v-model:visible="customModalVisible"
      title="自定义模态框示例"
      width="600px"
      @ok="handleCustomModalOk"
      @cancel="handleCustomModalCancel"
    >
      <div class="custom-modal-content">
        <p>这是一个自定义的模态框内容区域。</p>
        <a-form :model="formData" layout="vertical">
          <a-form-item label="用户名">
            <a-input v-model="formData.username" placeholder="请输入用户名" />
          </a-form-item>
          <a-form-item label="邮箱">
            <a-input v-model="formData.email" placeholder="请输入邮箱" />
          </a-form-item>
          <a-form-item label="描述">
            <a-textarea v-model="formData.description" placeholder="请输入描述" :rows="3" />
          </a-form-item>
        </a-form>
      </div>
    </ZlModal>
  </div>
</template>

<script>
import { useUserStore } from '../store/user'
import { message } from '../utils/message'
import { modal } from '../utils/modal'
import { drawer } from '../utils/drawer'
import ZlModal from '../layouts/ZlModal.vue'

export default {
  name: 'AboutView',
  components: {
    ZlModal
  },
  data() {
    return {
      customModalVisible: false,
      formData: {
        username: '',
        email: '',
        description: ''
      }
    }
  },
  methods: {
    // 在此添加组件方法
    getUserinfo(){
      console.log('获取用户信息')
      // 读取pinia中的用户信息
      console.log(useUserStore().getUserInfo)
      let data = {
        avatar: 'https://avatars.githubusercontent.com/u/1',
        nickname: '系统管理员',
      }
      useUserStore().updateUserInfo(data)
    },
    
    // 消息测试方法
    showSuccessMessage() {
      message.success('操作成功', '您的操作已成功完成，数据已保存到系统中。')
    },
    
    showErrorMessage() {
      message.error('操作失败', '网络连接异常，请检查您的网络设置后重试。', { duration: 5000 })
    },
    
    showWarningMessage() {
      message.warning('注意', '您即将执行危险操作，请确认后继续。')
    },
    
    showInfoMessage() {
      message.info('系统提示', '新版本已发布，建议您及时更新以获得更好的体验。')
    },
    
    showCustomMessage() {
      message.add({
        type: 'success',
        title: '自定义消息',
        content: '这是一个自定义的消息，可以设置更多参数。',
        duration: 10000,
        closable: true,
        showIcon: true
      })
    },
    
    clearAllMessages() {
      message.clear()
    },

    // 模态框测试方法
    async showConfirmModal() {
      const result = await modal.confirm({
        title: '删除确认',
        content: '确定要删除这个项目吗？删除后无法恢复。'
      })
      
      if (result) {
        message.success('删除成功', '项目已成功删除')
      } else {
        message.info('取消删除', '操作已取消')
      }
    },

    async showInfoModal() {
      await modal.info({
        title: '系统信息',
        content: '当前系统版本：v2.1.0\n更新时间：2024-01-15\n\n新功能：\n• 新增毛玻璃效果组件\n• 优化用户体验\n• 修复已知问题'
      })
    },

    async showWarningModal() {
      await modal.warning({
        title: '系统维护通知',
        content: '系统将于今晚23:00-01:00进行维护升级，期间可能无法正常访问，请提前保存您的工作。'
      })
    },

    async showErrorModal() {
      await modal.error({
        title: '连接失败',
        content: '无法连接到服务器，请检查网络连接或联系系统管理员。\n\n错误代码：ERR_NETWORK_TIMEOUT'
      })
    },

    showCustomModal() {
      this.customModalVisible = true
    },

    showFormModal() {
      this.formData = {
        username: '',
        email: '',
        description: ''
      }
      this.customModalVisible = true
    },

    handleCustomModalOk() {
      console.log('表单数据：', this.formData)
      message.success('提交成功', '表单数据已保存')
      this.customModalVisible = false
    },

    handleCustomModalCancel() {
      this.customModalVisible = false
    },

    // 抽屉测试方法
    showRightDrawer() {
      const { instance, close } = drawer.right({
        title: '右侧抽屉',
        width: '400px'
      })
      console.log('右侧抽屉已打开', instance)
    },

    showLeftDrawer() {
      drawer.left({
        title: '左侧抽屉',
        width: '350px'
      })
    },

    showTopDrawer() {
      drawer.top({
        title: '顶部抽屉',
        width: '250px'
      })
    },

    showBottomDrawer() {
      drawer.bottom({
        title: '底部抽屉',
        width: '300px'
      })
    },

    showCustomDrawer() {
      drawer.show({
        title: '自定义抽屉',
        width: '1000px',
        placement: 'right'
      })
    },

    showFormDrawer() {
      drawer.right({
        title: '表单抽屉',
        width: '450px',
        showFooter: true
      })
    }
  }
}
</script>

<style scoped>
.about {
  padding: 20px;
}

.message-test-section,
.modal-test-section,
.drawer-test-section {
  margin-top: 40px;
  padding: 20px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.message-test-section h2,
.modal-test-section h2,
.drawer-test-section h2 {
  margin-bottom: 20px;
  color: #2c3e50;
  font-size: 18px;
  font-weight: 600;
}

.button-group {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.button-group .arco-btn {
  min-width: 120px;
}

.custom-modal-content {
  padding: 10px 0;
}

.custom-modal-content p {
  margin-bottom: 20px;
  color: #7f8c8d;
  line-height: 1.6;
}
</style>
